import React, { useState, useEffect } from 'react';
import SvgComponent from '../../../common/components/SvgComponent/SvgComponent';
import PopUp from '../../../common/components/PopUp/PopUp';
import salaried from '../../../images/DocumentCheckList/salaried.svg';
import business from '../../../images/DocumentCheckList/business.svg';
import selfEmployed from '../../../images/DocumentCheckList/sep.svg';
import Architect from '../../../images/icons/LeadProfileIcons/Architect.svg';
import doctor from '../../../images/icons/LeadProfileIcons/doctor.svg';
import lawyer from '../../../images/icons/LeadProfileIcons/lawyer.svg';
import businessOwner from '../../../images/icons/LeadProfileIcons/businessOwner.svg';
import partnerShip from '../../../images/DocumentCheckList/freeLancer.svg';
import publicPrivateLTD from '../../../images/icons/LeadProfileIcons/publicPrivateLTD.svg';
import partnership from '../../../images/icons/LeadProfileIcons/partnership.svg';
import LLP from '../../../images/icons/LeadProfileIcons/LLP.svg';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CommonBtn from '../../../containers/LeadProfile/CommonBtn/CommonBtn';
import { sendWhatsAppDocAPI } from '../../../common/constants/api';
import {
  imgStyle,
  imgContainer,
  employeeContainer,
  moreDescriptionStyle,
  boxShadow,
  imageCheckboxContainer,
  imgHolder,
  checkCircleStyle
} from './DocumentCheckListLeadDashBoard.module.css';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '../Modal/modal';
import { Fragment } from 'react';
import CardWithCheck from '../../../common/components/CardWithCheck/CardWithCheck';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
const DocumentCheckListLeadDashBoard = ({
  showWhatsAppCheckList,
  setShowWhatsAppCheckList,
  leadId,
  currentApplicantId
}) => {
  const [typeOfEmployment, setTypeOfEmployment] = useState('');
  const [employerType, setEmployerType] = useState('');

  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [dontClose, setDontClose] = useState(true);

  useEffect(() => {
    if (!showWhatsAppCheckList) {
      setTypeOfEmployment('');
      setEmployerType('');
    }
  }, [showWhatsAppCheckList]);
  const sendWhatsAppDocFun = () => {
    setType('loading');
    setText('Sending documents please wait!...');
    setShow(true);
    setDontClose(true);
    sendWhatsAppDocAPI({
      leadId,
      applicantId: currentApplicantId,
      profession: typeOfEmployment,
      employerType
    })
      .then(res => {
        setTimeout(() => {
          setShow(false);
          setShowWhatsAppCheckList(false);
        }, 2000);
        setDontClose(false);
        setType('success');
        setText('Documents Sent Successfully.');
      })
      .catch(err => {
        setShow(false);
        setDontClose(false);
        setShowWhatsAppCheckList(false);
      });
  };

  const typeOfEmploymentOptions = [
    {
      imgUrl: salaried,
      displayTypeOfEmployment: 'Salaried',
      moreDescription: ' MNC/Govt/Similar',
      id: 'Salaried'
    },
    {
      imgUrl: selfEmployed,
      displayTypeOfEmployment: 'Self Employed',
      moreDescription: '(Doctor/CA/Architect)',
      id: 'SEP'
    },
    {
      imgUrl: business,
      displayTypeOfEmployment: 'Business Owner',
      moreDescription: '(Running own business)',
      id: 'SENP'
    }
  ];
  const selfEmployed_employerTypeOptions = [
    {
      imgUrl: businessOwner,
      displayEmployerType: <p>CA/CS/ICWA</p>,
      id: 'ca'
    },
    {
      imgUrl: doctor,
      displayEmployerType: <p>Doctor </p>,
      id: 'doctor'
    },
    {
      imgUrl: lawyer,
      displayEmployerType: <p>Lawyer </p>,
      id: 'lawyer'
    },
    {
      imgUrl: Architect,
      displayEmployerType: <p>Architect </p>,
      id: 'architect'
    },
    {
      imgUrl: businessOwner,
      displayEmployerType: (
        <p>
          Freelancer/
          <br />
          Consultant
        </p>
      ),
      id: 'freelancher'
    },
    {
      imgUrl: partnerShip,
      displayEmployerType: <p>Other </p>,
      id: 'other'
    }
  ];

  const businessOwner_employerTypeOptions = [
    {
      imgUrl: publicPrivateLTD,
      displayEmployerType: <p>Public / Private LTD</p>,
      id: 'public-ltd'
    },
    {
      imgUrl: businessOwner,
      displayEmployerType: <p>Proprietorship </p>,
      id: 'Proprietorship'
    },
    {
      imgUrl: partnership,
      displayEmployerType: <p>Partnership </p>,
      id: 'Partnership'
    },
    {
      imgUrl: LLP,
      displayEmployerType: <p>LLP </p>,
      id: 'LLP'
    }
  ];
  const getSvgComponent = imgUrl => {
    let newStr = imgUrl?.replace('data:image/svg+xml;base64,', '');

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: atob(newStr)
        }}
      />
    );
  };
  const ImageWithCheckBox = ({ imgUrl, title, keyValue }) => {
    return (
      <Fragment>
        <div className="w-full block md:hidden">
          <CardWithCheck
            key={keyValue}
            cardContainerStyle={{ width: '100%' }}
            label={title}
            containerStyle="w-full h-16 cursor-pointer py-2 my-1 px-1 mx-auto"
            checked={employerType == keyValue}
            img={getSvgComponent(imgUrl)}
            component={getSvgComponent(imgUrl)}
            iconprops={true}
            topRightCheck={true}
            rightCheck={false}
            onSetValue={() => {
              setEmployerType(keyValue);
            }}
          />
        </div>

        <div
          className={`mr-3 hidden md:block ${imageCheckboxContainer}`}
          key={keyValue}
        >
          {employerType == keyValue && (
            <CheckCircleIcon
              className={`${checkCircleStyle} text-orange-200`}
            />
          )}
          <div
            className={`w-full px-3 py-2 border border-grey-1009 rounded cursor-pointer ${imgHolder} pt-5`}
            onClick={() => setEmployerType(keyValue)}
          >
            <img src={imgUrl} className={`mx-auto `} />
          </div>
          <p className="font-open-sans text-black-850">{title}</p>
        </div>
      </Fragment>
    );
  };
  const useStyles = makeStyles({
    drawerBottomRoot: {
      ['@media (max-width:767px)']: {
        width: '100%',
        height: '100vh'
      },
      ['@media (min-width:768px)']: {
        display: 'none'
      }
    }
  });
  const classes = useStyles();

  const DiplayMode = ({ children }) => {
    return (
      <Fragment>
        <div className="hidden md:block">
          <Modal
            styleContainer={{
              minWidth: '500px',
              minHeight: '400px',
              maxHeight: '90vh',
              maxWidth: '750px'
            }}
            titleStyle={{ fontWeight: 'bold', fontSize: '20px' }}
            title="Send Document Checklist"
            show={showWhatsAppCheckList}
            setShow={setShowWhatsAppCheckList}
          >
            <hr className="text-grey-whatsAppBg mb-3 mt-1" />
            {children}
          </Modal>
        </div>
        <div className="block md:hidden">
          <Drawer
            anchor="bottom"
            open={showWhatsAppCheckList}
            onClose={() => setShowWhatsAppCheckList(false)}
            onOpen={() => setShowWhatsAppCheckList(true)}
            classes={{
              root: classes.drawerBottomRoot,
              paper: classes.drawerBottomRoot
            }}
          >
            <div className="w-full mt-24 px-2">
              <ArrowBackIosIcon
                onClick={() => {
                  setShowWhatsAppCheckList(false);
                }}
                className="text-black-400 border cursor-pointer  border-radius-full border-black-400 pl-2 rounded-full  py-1 text-center h-7 w-7 "
              />
              <span className="pl-3 text-black-1015 text-base text-black-400 font-open-sans">
                Document Checklist
              </span>
            </div>
            {children}
          </Drawer>
        </div>
      </Fragment>
    );
  };
  return (
    <DiplayMode>
      {showWhatsAppCheckList ? (
        <div
          className="bg-white mt-2 md:mt-0 rounded-md p-3 m-3 shadow-sm "
          style={{
            minHeight: '185px'
          }}
        >
          <div className="overflow-auto mt-2">
            <div
              className={`grid grid-cols-3 gap-4 py-2 px-2 w-full md:w-7/12 ${employeeContainer}`}
            >
              {typeOfEmploymentOptions.map((each, i) => {
                return (
                  <div className="table">
                    <div
                      onClick={() => {
                        setTypeOfEmployment(each?.id);
                        setEmployerType('');
                      }}
                      className={`mr-3 bg-green-greenWhite100   px-2 table  py-3 rounded  text-center  cursor-pointer ${imgContainer} ${
                        typeOfEmployment == each?.id
                          ? `bg-skyBlue-halfBaked border-skyBlue-halfBakedBorder border ${boxShadow}`
                          : 'hover:bg-skyBlue-halfBaked hover:border-skyBlue-halfBakedBorder hover:border'
                      }`}
                      key={i}
                    >
                      <img
                        className={`mx-auto w-full ${imgStyle}`}
                        src={each?.imgUrl}
                        alt={each?.displayTypeOfEmployment}
                      />
                    </div>
                    <p className="font-roboto text-xs font-medium text-black-850 ">
                      {each?.displayTypeOfEmployment}
                    </p>
                    <p
                      className={`font-roboto text-xs font-normal opacity-50 text-black-850 ${moreDescriptionStyle}`}
                    >
                      {each?.moreDescription}
                    </p>
                  </div>
                );
              })}
            </div>
            <div>
              {(typeOfEmployment == 'SEP' || typeOfEmployment == 'SENP') && (
                <p className="font-barlow-medium font-medium mb-2 mt-3 text-base px-2">
                  Employer Type
                </p>
              )}
              <div className="block md:flex gap-x-5 gap-y-3  mx-auto">
                {typeOfEmployment == 'SEP' &&
                  selfEmployed_employerTypeOptions.map((each, i) => {
                    return (
                      <ImageWithCheckBox
                        imgUrl={each?.imgUrl}
                        title={each?.displayEmployerType}
                        keyValue={each?.id}
                      />
                    );
                  })}

                {typeOfEmployment == 'SENP' &&
                  businessOwner_employerTypeOptions.map((each, i) => {
                    return (
                      <ImageWithCheckBox
                        imgUrl={each?.imgUrl}
                        title={each?.displayEmployerType}
                        keyValue={each?.id}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
          <CommonBtn
            buttonContainerClass="w-full"
            buttonParentClass="w-full"
            stylesBtn={{
              color: 'white',
              marginRight: 'auto'
            }}
            classNameStyle={`w-6/12 mx-auto text-center bg-green-tiber py-2 table rouded mt-8 mr-auto ${(!typeOfEmployment ||
              (typeOfEmployment != 'Salaried' && !employerType)) &&
              'opacity-50 cursor-not-allowed'}`}
            value="Send"
            onClick={() => {
              if (!typeOfEmployment) return;
              if (typeOfEmployment != 'Salaried' && !employerType) return;
              sendWhatsAppDocFun();
            }}
          />
        </div>
      ) : null}

      <PopUp
        type={type}
        text={text}
        setShow={setShow}
        show={show}
        dontClose={dontClose}
      />
    </DiplayMode>
  );
};

export default withErrorHandler(DocumentCheckListLeadDashBoard);
